import type { ReactElement } from 'react'
import type { ImportEndpointsRequest } from '../../../types/case-container'
import {
  Actions,
  ErrorBanner,
  InputSection,
  PreviewTable,
  SuccessView,
} from './json-import-modal/json-import-modal.parts'
import { type ImportResult, useJsonImportModal } from './json-import-modal/use-json-import-modal'

interface JsonImportModalProps {
  onClose: () => void
  onImport: (data: ImportEndpointsRequest) => Promise<ImportResult | null>
  importing: boolean
  apiError?: string | null
}

export function JsonImportModal({
  onClose,
  onImport,
  importing,
  apiError,
}: JsonImportModalProps): ReactElement {
  const state = useJsonImportModal({ onImport })
  const displayError = apiError ?? state.error

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="max-h-[80vh] w-full max-w-2xl overflow-y-auto rounded-xl bg-white p-6 shadow-xl dark:bg-slate-900">
        <h3 className="mb-4 text-lg font-semibold text-slate-900 dark:text-slate-100">
          Import from JSON
        </h3>
        {state.result ? (
          <SuccessView result={state.result} onClose={onClose} />
        ) : (
          <div className="space-y-4">
            <InputSection
              file={state.file}
              jsonText={state.jsonText}
              fileInputRef={state.fileInputRef}
              onFileChange={(event) => {
                void state.handleFileChange(event)
              }}
              onTextChange={state.handleTextChange}
            />
            {displayError && <ErrorBanner message={displayError} />}
            {state.preview.length > 0 && <PreviewTable items={state.preview} />}
            <Actions
              onClose={onClose}
              onImport={() => {
                void state.handleImport()
              }}
              importing={importing}
              previewCount={state.preview.length}
            />
          </div>
        )}
      </div>
    </div>
  )
}
